<div class="surface-card p-4 border-round-xl shadow-2 h-full cursor-pointer hover:shadow-4 transition-all transition-duration-200 flex flex-column align-items-center justify-content-center add-card"
    (click)="onClickCard()">
    <i class="pi pi-plus-circle text-4xl text-primary mb-3"></i>
    <h4 class="m-0 text-900 mb-2">Ajouter une organisation</h4>
</div>